import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SessionModalService } from '../../../core/services/session-modal.service';
import { PreventScrollDirective } from '../../../directives/prevent-scroll.directive';

@Component({
    selector: 'app-session-modal',
    standalone: true,
    imports: [CommonModule, TranslateModule, PreventScrollDirective],
    templateUrl: './session-modal.component.html'
})
export class SessionModalComponent {
    sessionModalService = inject(SessionModalService);

    /**
     * Closes the session modal.
     */
    closeModal() {
        this.sessionModalService.hide();
    }
}
